import { BuildingInfo } from "../types/member";

import { SpaceItem } from "../services/memberServices";

export const getBuildingKey = (item: SpaceItem | Partial<BuildingInfo>) => {
  return `${item?.buildingId}-${item?.buildingFloorId}`;
};

export const getBuildingLabel = (item: SpaceItem | BuildingInfo) => {
  return `${item?.buildingName} ${item?.buildingFloorName}`;
};
